class LineFitter {
  constructor() {
    this.count = 0;
    this.sumX = 0;
    this.sumX2 = 0;
    this.sumXY = 0;
    this.sumY = 0;
  }

  add(x, y) {
    ++this.count;
    this.sumX += x;
    this.sumX2 += x ** 2;
    this.sumXY += x * y;
    this.sumY += y;
  }

  project(x) {
    const det = this.count * this.sumX2 - this.sumX ** 2;
    const offset = (this.sumX2 * this.sumY - this.sumX * this.sumXY) / det;
    const scale = (this.count * this.sumXY - this.sumX * this.sumY) / det;
    return offset + x * scale;
  }

  addMulti(data) {
    for (let i = 0; i < data.length; ++i) {
      this.add(i, data[i]);
    }
  }

  addMultiWithDates(data) {
    for (const d of data) {
      this.add((new Date(d.date)).getTime(), d.rating);
    }
  }
}

const linearProject = (data, x) => {
  const fitter = new LineFitter();
  for (let i = 0; i < data.length; ++i) {
    fitter.add(i, data[i]);
  }
  return fitter.project(x);
};

export {LineFitter, linearProject};